module.exports = "/static/assets/566c8436a098b4c02fed0cc89795c68e.png";